import { DataSourceParams } from '@fleet-beat/core';

export interface DataAutocompleteStorageParams<Params>
  extends DataSourceParams<
    {
      input?: string;
      sessiontoken?: string;
      search?: string;
      limit?: number;
      offset?: number;
      total?: number;
    },
    Params
  > {}
